export default "__VITE_ASSET__CVTH4UKt__"